import React from "react";
import { Button } from "semantic-ui-react";
import { WidgetProps } from "../types";
import Prompt from "../Prompt";
import Summary, { SummaryText, Actions } from "../Summary";

/**
 * The course's three short reflective prompts. The question carries the
 * instruction; this is just the input.
 */
const Reflection: React.FC<WidgetProps> = ({
  payload,
  update,
  submit,
  submitting,
  finished,
  question,
  currentUser,
}) => {
  const complete = (payload.body || "").trim().length > 1;

  if (finished) {
    return (
      <Summary question={question} currentUser={currentUser}>
        <SummaryText>{payload.body}</SummaryText>
      </Summary>
    );
  }

  return (
    <div className="ui form assignment-form">
      <Prompt question={question} currentUser={currentUser} />

      <div className="field">
        <textarea
          rows={4}
          placeholder="Type your answer"
          value={payload.body || ""}
          onChange={(e) => update({ ...payload, body: e.target.value })}
        />
      </div>

      <Actions>
        <Button
          primary
          circular
          className="challenge-submit"
          disabled={!complete || submitting}
          loading={submitting}
          onClick={submit}
        >
          Submit
        </Button>
      </Actions>
    </div>
  );
};

export default Reflection;
